"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var image_1 = __importDefault(require("../utils/image"));
var proxiedImageUtil = {
    getVariants: function (images) {
        return image_1.default.getVariants(images.map(function (image) { return (__assign(__assign({}, image), { url: image.url.replace('://', '://nuts.com/images/rackcdn/') })); }));
    },
};
exports.default = proxiedImageUtil;
//# sourceMappingURL=imageProxied.js.map